import React, { useRef, useEffect } from 'react';
import { Grid, GridItem } from '@deal/components';
import { usePathContext } from '../../context/PathContext.js';
import LogoContainer from '../../components/Logo/index.js';
import InterstitialViewModel from './components/InterstitialViewModel/index.js';
import Question from './components/QuestionViewModel/index.js';
import ProgressBar from '../../components/ProgressBar/index.js';
import DryRunInfo from '../../components/DryRunInfoViewModel/index.js';
import ErrorViewModel from '../../components/ErrorViewModel/index.js';
import CreaetAccountViewModel from '../../components/CreateAccountViewModel/index.js';
import PathErrorViewModel from '../../components/PathErrorViewModel/index.js';
import styles from './styles.css.js';

var BasicLayout = function BasicLayout() {
  var _a;

  var pathContext = usePathContext();
  var activeNode = pathContext.activeNode;

  if (!activeNode) {
    throw new Error('Attempted render of a path layout without an active node');
  }

  var scrollTargetRef = useRef(null);
  useEffect(function () {
    var _a;
    /**
     * The `scrollTo` property won't work when the path is rendered in the `Modal` placement.
     * The `smooth` property also is browser by browser, but degrades gracefully.
     */


    if (scrollTargetRef) {
      (_a = scrollTargetRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [activeNode]);
  return React.createElement("div", {
    className: styles.pageContainer,
    ref: scrollTargetRef
  }, React.createElement(ProgressBar, null), React.createElement(LogoContainer, {
    className: styles.logoMark,
    color: "dark",
    mark: "word"
  }), pathContext.pathGraphFlowErrors && React.createElement(PathErrorViewModel, {
    pathErrorViewModel: pathContext.pathGraphFlowErrors
  }), React.createElement(Grid, {
    margins: pathContext.pathPlacement !== 'modal'
  }, React.createElement(GridItem, {
    col: 2
  }, React.createElement("div", {
    className: styles.contentContainer,
    key: (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id
  }, activeNode.viewModel.__typename === 'CreateAccountPathNodeFlowViewModel' && React.createElement(CreaetAccountViewModel, {
    createAccountViewModel: activeNode.viewModel
  }), activeNode.viewModel.__typename === 'ErrorPathNodeFlowViewModel' && React.createElement(ErrorViewModel, {
    errorViewModel: activeNode.viewModel
  }), activeNode.viewModel.__typename === 'DryRunInfoPathNodeFlowViewModel' && React.createElement(DryRunInfo, {
    dryRunInfoViewModel: activeNode.viewModel
  }), activeNode.viewModel.__typename === 'InterstitialPathNodeFlowViewModel' && React.createElement(InterstitialViewModel, {
    interstitialNodeViewModel: activeNode.viewModel
  }), activeNode.viewModel.__typename === 'QuestionsPathNodeFlowViewModel' && React.createElement(Question, null)))));
};

export default BasicLayout;
//# sourceMappingURL=index.js.map
